import { useMutation } from '@occc-app/dataAccessLayer/utils';
import {
  PromoCodesUploadProcessMutationOptions,
  PromoCodesUploadSignedUrlGenerateMutationOptions,
  usePromoCodesUploadProcessMutation,
  usePromoCodesUploadSignedUrlGenerateMutation,
} from '@occc/graphql';

export const usePromoCodesUploadSignedUrlGenerate = (
  baseOptions?: PromoCodesUploadSignedUrlGenerateMutationOptions,
) => useMutation(usePromoCodesUploadSignedUrlGenerateMutation, baseOptions);

export const usePromoCodesUploadProcess = (baseOptions?: PromoCodesUploadProcessMutationOptions) =>
  useMutation(usePromoCodesUploadProcessMutation, baseOptions);
